import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Breadcrumbs, Paper, Typography } from '@mui/material';
import UmbrellaFoodDonorAddForm from '../components/UmbrellaFoodDonorAddForm';
import * as umbrellaFoodDonorsActions from '../actions/umbrellaFoodDonors';
import routes from '../routes';
import OverlayLoader from '../components/OverlayLoader';
import NotificationsContext from '../context/NotificationsContext/NotificationsContext';
import * as notificationsHelper from '../helpers/notifications';

const UmbrellaFoodDonorAddView = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const notificationsContext = useContext(NotificationsContext);

  const createUmbrellaFoodDonor = async (umbrellaFoodDonorData) => {
    await dispatch(umbrellaFoodDonorsActions.createUmbrellaFoodDonor(umbrellaFoodDonorData));

    notificationsHelper.addNotification('Umbrella Food Donor added successfully!', notificationsContext);

    return history.push(routes.umbrellaFoodDonors);
  };

  return (
    <>
      <Breadcrumbs sx={{ padding: 1 }} aria-label="Breadcrumbs">
        <Link color="inherit" to={routes.umbrellaFoodDonors}>
          Umbrella Food Donors
        </Link>

        <Typography color="textPrimary">Add an Umbrella Food Donor</Typography>
      </Breadcrumbs>

      <OverlayLoader isLoading={false}>
        <Paper sx={{ padding: { xs: 1, sm: 2 } }}>
          <UmbrellaFoodDonorAddForm createUmbrellaFoodDonor={createUmbrellaFoodDonor} />
        </Paper>
      </OverlayLoader>
    </>
  );
};

export default UmbrellaFoodDonorAddView;
